import React from 'react'
import { getFileVisual } from 'utils/fileVisuals'
import { classNames } from '../classNames'
import styles from './styles.module.css'

interface IFileThumbnailProps {
  name: string
  mime: string
  compact?: boolean
}

/** Static file artwork, safe inside either a preview link or a selectable subtask card. */
export function FileThumbnail({ name, mime, compact = false }: IFileThumbnailProps) {
  const { Icon, color, bg } = getFileVisual(mime)
  const dot = name.lastIndexOf('.')
  const hasExtension = dot > 0 && dot < name.length - 1
  const basename = hasExtension ? name.slice(0, dot) : name
  const extension = hasExtension ? name.slice(dot) : ''

  return (
    <span
      className={classNames(styles.tile, compact && styles.compact)}
      style={{ background: bg }}
      title={name}
      role={compact ? 'img' : undefined}
      aria-label={compact ? name : undefined}
    >
      <Icon size={compact ? 32 : 36} color={color} aria-hidden="true" />
      {!compact && (
        <span className={styles.name} dir="ltr">
          <bdi className={styles.basename}>{basename}</bdi>
          {extension && <span className={styles.extension}>{extension}</span>}
        </span>
      )}
    </span>
  )
}
